/**
 * Renders the two modals used on the Business Office page:
 * Comments Writeback Validation and Trigger RPA confirmation.
 * @module BoModals
 */

import CommentsWritebackValidationModal from "../../../../../components/modals/commentsWritebackValidationModal/commentsWritebackValidationModal";
import TriggerRpaNewModal from "../../../../../components/modals/triggerRpaNewModal/triggerRpaNewModal";
import { AllCommentsProps } from "../../../../../data-model/busniessOfficeNote";
import { ValidateTemplateRequestItem } from "../../../../../data-model/templateValidatorModel";
import { ModalId } from "../../../../../enums/modalId";

/**
 * Inputs for {@link BoModals}: which modal is open, validation payload, and handlers.
 */
interface BoModalsProps {
  openedModalId: string | null;
  commentsWritebackValidationPayload: ValidateTemplateRequestItem[];
  allCommentsForUI: AllCommentsProps[];
  onProceedToTriggerRpa: () => void;
  onTriggerRpa: (selectedOrderIds?: string[]) => void;
  onClose: () => void;
  loading?: boolean;
}

/**
 * Conditionally renders Business Office modals based on the active modal ID.
 *
 * @param props - Modal ID, validation payload, comments, and action callbacks.
 */
const BoModals = ({
  openedModalId,
  commentsWritebackValidationPayload,
  allCommentsForUI,
  onProceedToTriggerRpa,
  onTriggerRpa,
  onClose,
  loading = false,
}: BoModalsProps) => {
  return (
    <>
      {openedModalId === ModalId.COMMENTS_WRITEBACK_VALIDATION_MODAL && (
        <CommentsWritebackValidationModal
          validationPayload={commentsWritebackValidationPayload}
          businessOfficeComments={allCommentsForUI}
          onProceedToTriggerRpa={onProceedToTriggerRpa}
          onClose={onClose}
        />
      )}
      {openedModalId === ModalId.TRIGGER_RPA_MODAL_NEW && (
        <TriggerRpaNewModal
          onTriggerRpa={onTriggerRpa}
          onClose={onClose}
          loading={loading}
        />
      )}
    </>
  );
};

export default BoModals;
